import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router";
import { AiOutlineMenu } from "react-icons/ai";
import NavItem from "../../components/layout/header/NavItem";
import SignUpBtn from "../../components/layout/header/SignUpBtn";

// import style
import "../../style/pages/layout/header.scss";

// import assets
import LogoSrc from "../../assets/images/logo.webp";

const menuList = [
  {
    link: "/about",
    title: "About",
    subTitle: "学校紹介",
  },
  {
    link: "/articles",
    title: "Articles",
    subTitle: "記事",
  },
  {
    link: "/classes",
    title: "Classes",
    subTitle: "クラス案内",
  },
  {
    link: "/shop",
    title: "Shop",
    subTitle: "ショップ",
  },
  {
    link: "/videos",
    title: "Videos",
    subTitle: "動画",
  },
];

const Header = () => {
  const location = useLocation();
  const [isResponsive, setIsResponsive] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsResponsive(false);
      }
    };

    // Attach listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Cleanup listener
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`header-section ${
        location.pathname === "/"
          ? "background-green"
          : location.pathname === "/about"
          ? "background-green"
          : location.pathname === "/articles"
          ? "background-orange"
          : location.pathname === "/classes"
          ? "background-pink"
          : location.pathname === "/shop"
          ? "background-blue"
          : location.pathname === "/videos"
          ? "background-purple"
          : location.pathname === "/register"
          ? "background-red"
          : location.pathname === "/contact"
          ? "background-lightgreen"
          : location.pathname === "/question"
          ? "background-black"
          : "background-green"
      }`}
    >
      <div className="header-main container">
        {location.pathname !== "/" ? (
          <a href="/" className="logo">
            <img src={LogoSrc} alt="logo" />
          </a>
        ) : (
          <div className="logo placeholder">
            <span style={{ visibility: "hidden" }}>
                <img src={LogoSrc} alt="logo" />
            </span>
          </div>
        )}

        <button
          className="responsive-menu-bar"
          onClick={() => setIsResponsive(true)}
        >
          <AiOutlineMenu />
        </button>

        {menuList.map((item, key) => {
          return <NavItem item={item} key={key} />;
        })}

        <div className="btn-view">
          <SignUpBtn />
        </div>
      </div>

      <div
        ref={menuRef}
        className={`responsive-nav-menu ${
          location.pathname === "/"
            ? "background-green"
            : location.pathname === "/about"
            ? "background-green"
            : location.pathname === "/articles"
            ? "background-orange"
            : location.pathname === "/classes"
            ? "background-pink"
            : location.pathname === "/shop"
            ? "background-blue"
            : location.pathname === "/videos"
            ? "background-purple"
            : location.pathname === "/register"
            ? "background-red"
            : location.pathname === "/contact"
            ? "background-lightgreen"
            : location.pathname === "/question"
            ? "background-black"
            : "background-green"
        } ${isResponsive ? "open" : ""}`}
      >
        <div className="responsive-nav-section">
          <a href="/" className="responsive-nav-logo">
            <img src={LogoSrc} alt="logo" />
          </a>

          {menuList.map((item, key) => {
            return <NavItem item={item} key={key} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Header;
